'use client'
import * as React from 'react'
import { algoliaAnalytics, AlgoliaEventName } from 'algolia/algolia'
import { algoliaContentIndex } from 'algolia/algolia-content'
import { useIsLoggedInQuery } from 'auth/hooks'

import { useLastViewedProdGetCookie } from '@web/hooks/use-last-viewed-prod-set-cookie'

export function ProductViewInCategoryPageAnalytics({ prodIds }: { prodIds: string[] }) {
  const lastViewedProduct = useLastViewedProdGetCookie()
  // We need to wait for the isLoggedInQuery to be loaded, otherwise we will send the event as an anonymous user
  const { isPending } = useIsLoggedInQuery()

  React.useEffect(() => {
    if (lastViewedProduct && !isPending && prodIds.includes(lastViewedProduct)) {
      const productIndex = prodIds.indexOf(lastViewedProduct)

      algoliaAnalytics('viewedObjectIDs', {
        index: algoliaContentIndex,
        eventName: AlgoliaEventName.PRODUCT_LIST_VIEWED,
        objectIDs: prodIds.slice(
          Math.min(productIndex, Math.max(prodIds.length - 20)),
          productIndex + 20,
        ),
      })
    }
  }, [prodIds, lastViewedProduct, isPending])

  return null
}
